<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">gavel</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Manifestar NF-e</h2>
    <span class="modal-subtitle">NF-e {{ data.numeroNota }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="option-list" role="radiogroup" aria-label="Tipo de manifestação">
    @for (evento of eventos; track evento.idTipoEvento) {
      <span
        [matTooltip]="evento.motivoJaRegistrado"
        [matTooltipDisabled]="data.idTipoEventoManifestacaoAtual !== evento.idTipoEvento">
        <button
          type="button"
          class="action-card-action"
          role="radio"
          [attr.aria-checked]="idTipoEventoSelecionado === evento.idTipoEvento"
          [disabled]="data.idTipoEventoManifestacaoAtual === evento.idTipoEvento"
          (click)="idTipoEventoSelecionado = evento.idTipoEvento">
          <app-action-card
            [title]="evento.rotulo"
            [description]="evento.descricao"
            [interactive]="true"
            [disabled]="data.idTipoEventoManifestacaoAtual === evento.idTipoEvento"
            [selected]="idTipoEventoSelecionado === evento.idTipoEvento">
            <mat-icon cardActions class="material-symbols-outlined" aria-hidden="true">
              {{ idTipoEventoSelecionado === evento.idTipoEvento ? 'radio_button_checked' : 'radio_button_unchecked' }}
            </mat-icon>
          </app-action-card>
        </button>
      </span>
    }
  </div>

  @if (isJustificativaObrigatoria) {
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Justificativa</mat-label>
      <textarea
        matInput
        rows="4"
        maxlength="255"
        [formControl]="justificativa"
        placeholder="Informe o motivo da operação não realizada"></textarea>
      <mat-hint align="end">{{ justificativa.value.length }}/255</mat-hint>
      @if (justificativa.hasError('required') || justificativa.hasError('minlength')) {
        <mat-error>Informe ao menos {{ tamanhoMinimoJustificativa }} caracteres.</mat-error>
      }
    </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <span [matTooltip]="idTipoEventoSelecionado === null ? 'Selecione o tipo de manifestação.' : ''">
    <button
      mat-flat-button
      class="btn-primary"
      type="button"
      [disabled]="idTipoEventoSelecionado === null"
      (click)="confirmar()">
      Manifestar
    </button>
  </span>
</mat-dialog-actions>
